import { MainInner } from "@/styles/global";
import {
  Paragraph,
  ParagraphIngress,
  TextLinkCss,
  Wysiwyg,
  h2,
  h3,
  h4,
  h5,
  h6,
} from "@/styles/typography";
import styled from "styled-components";
import { Link as GatsbyLink } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const Inner = styled(MainInner)`
  gap: 20px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 8px 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    max-width: 800px;
    margin: 32px auto;
  }
`;

const TextContent = styled(Wysiwyg)``;

const H2 = styled(h2)``;

const H3 = styled(h3)``;

const H4 = styled(h4)``;

const H5 = styled(h5)``;

const H6 = styled(h6)``;

const Ingress = styled(ParagraphIngress)``;

const Link = styled(GatsbyLink)`
  ${TextLinkCss}
  color: ${({ theme }) => theme.colors.primaryPurple};
  display: flex;
  gap: 8px;
  margin: 8px 0;

  svg {
    width: 18px;
    height: 18px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin: 16px 0;
  }
`;

const ButtonWrapper = styled.div``;

const Image = styled(GatsbyImage)`
  aspect-ratio: 3/2;
  border-radius: 4px;
`;

const VimeoHero = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;

  iframe {
    border-radius: 4px;
    width: 100%;
    height: 100%;
    aspect-ratio: 16/9;
    border: none;
    background: ${({ theme }) => theme.colors.coreDark};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-bottom: 24px;
  }
`;

const VideoWrapper = styled.div`
  position: relative;
`;

const IconWrapper = styled.div`
  transform: scale(-1, 1);
  top: -30px;
  position: absolute;
  right: -40px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    top: -20px;
    right: -10px;

    svg {
      width: 32px;
      height: 36px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    top: -30px;
    right: -40px;
  }
`;

const InfoBox = styled.div<{ $bgColor: string }>`
  background-color: ${({ $bgColor }) => $bgColor};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: 4px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 800px;
    padding: 24px;
  }
`;

const InfoBoxTitle = styled(h4)``;

const InfoBoxLink = styled.a`
  ${TextLinkCss}
  color: ${({ theme }) => theme.colors.primaryPurple};
  display: flex;
  gap: 8px;

  svg {
    width: 18px;
    margin-top: -2px;
    path {
      stroke: ${({ theme }) => theme.colors.primaryPurple};
    }
  }
`;

const Text = styled(Paragraph)``;

const S = {
  Inner,
  Wrapper,
  TextContent,
  H2,
  H3,
  H4,
  H5,
  H6,
  Ingress,
  Link,
  ButtonWrapper,
  Image,
  VimeoHero,
  VideoWrapper,
  IconWrapper,
  InfoBoxLink,
  InfoBox,
  InfoBoxTitle,
  Text,
};

export default S;
